
import emailjs from 'emailjs-com'
import React, { useState, useRef } from 'react';
import { useNavigate } from "react-router-dom";

const initialState = {
  from_name: '',
  mobile: '',
  issue: '',
  service: '',
  warranty: '',
  pincode: '',
  dateip: '',
  timeslot: '',
  adress: '',
}
export const Contact = (props) => {
  const [{ from_name, mobile, issue, service, warranty, pincode,dateip, timeslot, adress }, setState] = useState(initialState);
  const formRef = useRef();
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target
    setState((prevState) => ({ ...prevState, [name]: value }))
  }

  const validateMobile = (mobile) => {
    const regex = /^\d{10}$/; // Regex for 10 digit mobile number
    return regex.test(mobile);
  };
  const clearState = () => setState({ ...initialState })

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateMobile(mobile)) {
      alert("Please enter a valid 10-digit mobile number.");
      return;
    }
    console.log(from_name, mobile, issue, service, warranty, pincode, dateip, timeslot, adress)
    emailjs
      .sendForm(
        'service_156qo9u', 'template_rli3glb', e.target, 'DOFeyEAm_0FtUzs8g'
      )
      .then(
        (result) => {
          alert('Your Call Back Request has been submitted , you will get a get from our team within 5-10 min. Thanks for your patience')
          clearState();
          formRef.current.reset();
          navigate("/thanks");
        },
        (error) => {
          console.log(error.text)
        }
      )
  }
  return (
    <div>
      <div id='contact'>
        <div className='container'>
          <div className='col-md-6'>
            <div className='row'>
              <div className='section-title'>
                <h2>SUBMIT A CALL BACK REQUEST</h2>
                <p>
                  Please fill out the form below to send us an email and we will
                  get back to you as soon as possible.
                </p>
              </div>
              <form ref={formRef} name='sentMessage' validate onSubmit={handleSubmit}>
                <div className='row'>
                  <div className='col-md-6'>
                    <div className='form-group'>
                      <input
                        type='text'
                        id='name'
                        name='from_name'
                        className='form-control'
                        placeholder='Full Name*'
                        required
                        onChange={handleChange}
                      />
                      <p className='help-block text-danger'></p>
                    </div>
                  </div>
                  <div className='col-md-6'>
                    <div className='form-group'>
                      <input
                        type='number'
                        id='mobile'
                        name='mobile'
                        className='form-control'
                        placeholder='Mobile Number*'
                        required
                        onChange={handleChange}
                      />
                      <p className='help-block text-danger'></p>
                    </div>
                  </div>
                </div>
                <div className='row'>
                  <div className='col-md-6'>
                    <div className='form-group'>
                      <select className="form-select form-control" id='issue' name='issue' aria-label="select Issue" onChange={handleChange}>
                        <option selected>Select Issue</option>
                        <option value="complete-not-working">Complete Not Working</option>
                        <option value="alarm">Alarm</option>
                        <option value="noise-or-sound">Noise or Sound</option>
                        <option value="tank-fill-slow">Tank fill Slow</option>
                        <option value="outer-filter-change">Outer Filter Change</option>
                        <option value="all-filter-change">All filter Change</option>
                        <option value="bad-taste">Bad Taste</option>
                        <option value="other-issue">Other Issue</option>
                      </select>
                      <p className='help-block text-danger'></p>
                    </div>
                  </div>

                  <div className='col-md-6'>
                    <div className='form-group'>
                      <select className="form-select form-control" id='service' name='service' aria-label="Select Service" onChange={handleChange}>
                        <option selected>Choose Service</option>
                        <option value="routine-checkup">RO Routine Checkup</option>
                        <option value="repair-service">RO Repair Service</option>
                        <option value="installation-service">RO Installation Service</option>
                        <option value="change-filter-inside-machine">Change Filter (Inside Machine)</option>
                        <option value="change-filter-outside-machine">Change Filter (Outside Machine)</option>
                        <option value="inspection-and-estimate">RO Inspection and Estimate</option>
                      </select>
                      <p className='help-block text-danger'></p>
                    </div>
                  </div>
                </div>
                <div className='row'>
                  <div className='col-md-6'>
                    <div className='form-group'>
                    
                    
                    <input
                      type="date"
                      id="dateip"
                      name='dateip'
                      style={{ width: "100%",color: "black" }}
                      onChange={handleChange}
                      placeholder='Enter Date for Visit'
                    />
                      <p className='help-block text-danger'></p>
                    </div>
                  </div>

                  <div className='col-md-6'>
                    <div className='form-group'>
                      <select className="form-select form-control" id='timeslot' name='timeslot' aria-label="Time Slot" onChange={handleChange}>
                        <option selected>Select Time</option>
                        <option value="8amto10am">8AM to 10AM</option>
                        <option value="10amto12pm">10AM to 12PM</option>
                        <option value="12pmto2pm">12PM to 2PM</option>
                        <option value="2pmto4pm">2PM to 4PM</option>
                        <option value="4pmto6pm">4PM to 6PM</option>
                        <option value="6pmto8pm">6PM to 8PM</option>
                      </select>

                      <p className='help-block text-danger'></p>
                    </div>
                  </div>
                </div>

                <div className='row'>
                  <div className='col-md-6'>
                    <div className='form-group'>
                      <select className="form-select form-control" id='warranty' name='warranty' aria-label="Warranty Status" onChange={handleChange}>
                        <option selected>Warranty Status</option>
                        <option value="nowarranty">Out of Warranty</option>
                        <option value="warranty">In Warranty</option>
                        <option value="dontknow">Doesn't Know </option>
                      </select>
                      <p className='help-block text-danger'></p>

                    </div>
                  </div>
                  <div className='col-md-6'>
                    <div className='form-group'>
                      <input
                        type='number'
                        id='pincode'
                        name='pincode'
                        className='form-control'
                        placeholder='Pincode*'
                        required
                        onChange={handleChange}
                      />
                      <p className='help-block text-danger'></p>

                    </div>
                  </div>
                </div>

                <div className='form-group'>
                  <textarea
                    name='adress'
                    id='adress'
                    className='form-control'
                    rows='3'
                    placeholder='Address*'
                    required
                    onChange={handleChange}
                  ></textarea>
                  <p className='help-block text-danger'></p>
                </div>
                <div id='success'></div>

                <div id='success'></div>
                <button type='submit' className='btn btn-custom btn-lg'>
                  Get a Call Back
                </button>
              </form>
            </div>
          </div>

          <div className='col-md-5 col-md-offset-1 contact-info'>
            <div className='contact-item'>
              <img src="img/call.jpeg" className="img-responsive" alt="water purifier" />{" "}
            </div>
          </div>

        </div>
      </div>

    </div>
  )
}
